import React from 'react';
import { useLocation } from 'react-router-dom';

import wnLogoSvg from 'images/logos/wn-logo-gold-gray.svg';
import waitChapelIllustration from './wait-chapel.png';

const Downtime = () => {
  const oLocation = useLocation();
  const { sMessage } = oLocation.state;

  return (
    <>
      <header className='landingPage__header'>
        <img
          src={wnLogoSvg}
          className='landingPage__headerLogo'
          alt='Wake Network logo'
        />
        <a href='mailto:wknthelp@wfu.edu' className='landingPage__contactLink'>
          wknthelp@wfu.edu
        </a>
      </header>
      <div
        className='downtime__wrapper'
        style={{ backgroundImage: `url('${waitChapelIllustration}')` }}
      >
        <div className='downtime__container'>
          <h1 className='downtime__message'>
            WakeNetwork is Down for Maintenance
          </h1>
          {sMessage && <h2 className='downtime__message'>{sMessage}</h2>}
        </div>
      </div>
    </>
  );
};

export default Downtime;
